import React from "react";
import { Modal, Button, Form } from "react-bootstrap";

const ModalProductosBodegas = ({
                                        show,
                                        onHide,
                                        bodegas = [],
                                        data,
                                        setData,
                                        onSave
                                    }) => {

    // Cuando cambia un stock, actualizamos en data.stockBodegas
    const handleStockChange = (bodegaId, value) => {
        const numero = Number(value.replace(/\D/g, "")) || 0;

        const nuevoStock = data.stockBodegas.map(item =>
            item.bodegaId === bodegaId
                ? { ...item, stock: numero }
                : item
        );

        setData({ ...data, stockBodegas: nuevoStock });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSave();
    };

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header
                closeButton
                style={{ background: "linear-gradient(90deg, #ff9ccf 0%, #d63384 100%)", color: "white" }}
            >
                <Modal.Title>📦 Ingresar Stock por Bodega</Modal.Title>
            </Modal.Header>

            <Form onSubmit={handleSubmit}>
                <Modal.Body>
                    {bodegas.length === 0 && <p>No hay bodegas cargadas.</p>}

                    {bodegas.map((bodega) => (
                        <Form.Group key={bodega.id} className="mb-3">
                            <Form.Label>
                                <strong>{bodega.nombre}</strong> – {bodega.puntoVenta?'Punto de Venta 🏪✔️':'Bodega 📦➡️'}
                            </Form.Label>

                            <Form.Control
                                type="text"
                                min="0"
                                placeholder="Ingrese stock"
                                value={
                                    data.stockBodegas.find(x => x.bodegaId === bodega.id)?.stock ?? 0
                                }
                                onChange={(e) => handleStockChange(bodega.id, e.target.value)}
                                style={{ borderRadius: "8px" }}
                            />
                        </Form.Group>
                    ))}
                </Modal.Body>

                <Modal.Footer className="d-flex justify-content-center">
                    <Button
                            style={{
                                background: "linear-gradient(90deg, #ff9ccf 0%, #d63384 100%)",
                                border: "none"
                            }}
                            onClick={onHide}
                    >
                        ✖️ Cerrar
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};

export default ModalProductosBodegas;
